import React from 'react';

const SearchIcon = (props) => (
  <svg {...props} viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5302 13.5069C13.8674 13.1697 14.479 13.2336 14.7523 13.5069L17.7943 16.5486C18.1312 16.8858 18.1312 17.4335 17.7943 17.7706C17.4571 18.1078 16.8455 18.0439 16.5722 17.7706L13.5302 14.7289C13.193 14.3917 13.193 13.8441 13.5302 13.5069Z'
      fill={props.fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.1349 8.06799C16.1349 3.61217 12.5227 0 8.06799 0C3.61217 0 0 3.61217 0 8.06799C0 12.5227 3.61217 16.1349 8.06799 16.1349C12.5227 16.1349 16.1349 12.5227 16.1349 8.06799ZM14.4055 8.06736C14.4055 4.56666 11.5681 1.72814 8.06736 1.72814C4.56666 1.72814 1.72814 4.56666 1.72814 8.06736C1.72814 11.5681 4.56666 14.4055 8.06736 14.4055C11.5681 14.4055 14.4055 11.5681 14.4055 8.06736Z'
      fill={props.fill}
    />
  </svg>
);

export default SearchIcon;
